(function () {
  'use strict';
  var blocked = false;
  var hiddenApi = null;
  var scheduled = false;
  function apply(open) {
    blocked = open;
    document.documentElement.classList.toggle('dalray-popup-open', open);
    var api = window.tidioChatApi;
    if (!api) return;
    if (open && hiddenApi !== api) {
      api.hide();
      hiddenApi = api;
    } else if (!open && hiddenApi === api) {
      api.close();
      api.show();
      hiddenApi = null;
    }
  }
  function scan() {
    scheduled = false;
    var dialogs = document.querySelectorAll('[data-kl-scroll-locking-modal="true"][role="dialog"], #CartDrawer[role="dialog"]');
    var visible = Array.prototype.some.call(dialogs, function (dialog) {
      if (dialog.hidden || dialog.getAttribute('aria-hidden') === 'true') return false;
      var style = window.getComputedStyle(dialog);
      return style.display !== 'none' && style.visibility !== 'hidden' && dialog.getClientRects().length > 0;
    });
    apply(visible);
  }
  function schedule() {
    if (!scheduled) {
      scheduled = true;
      window.requestAnimationFrame(scan);
    }
  }
  window.addEventListener('klaviyoForms', function (event) {
    var type = event.detail && event.detail.type;
    if (type === 'open') apply(true);
    if (type === 'open' || type === 'close' || type === 'redirectedToUrl') schedule();
  });
  function ready() { apply(blocked); schedule(); }
  document.addEventListener('tidioChat-ready', ready);
  if (window.tidioChatApi) window.tidioChatApi.on('ready', ready);
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['hidden', 'aria-hidden', 'data-kl-scroll-locking-modal', 'open', 'active', 'style']
  });
  schedule();
}());